export enum Permission {
  'Organisation' = 'My Organisation',
  'Organisation.Info' = 'Information',
  'Organisation.ViewMembers' = 'View Members',
  'OrgAdmin' = 'My Organisation - Management',
  'OrgAdmin.Members' = 'Edit Organisation Members',
  'OrgAdmin.DisplayLanguage' = 'Display Language',
  'OrgAdmin.ManageFacilitators' = 'Manage Facilitators',
  'Network' = 'My Network',
  'Network.Organisations' = 'Organisations',
  'Network.Members' = 'Members',
  'Events' = 'My Events',
  'MyLibrary' = 'My Library',
  'MyLibrary.Assessments' = 'Assessments',
  'MyLibrary.Feedback' = 'Feedback',
  'MyLibrary.Games' = 'Games',
  'MyLibrary.Zones' = 'Zones',
  'GlobalLibrary' = 'Global Library',
  'GlobalLibrary.Assessments' = 'Global Assessments',
  'GlobalLibrary.Feedback' = 'Global Feedback',
  'GlobalLibrary.Games' = 'Global Games',
  'GlobalLibrary.Zones' = 'Global Zones',
  'Reports' = 'Reports',
  'Admin' = 'Admin',
  'Admin.Users' = 'All Users',
  'Admin.Organisations' = 'Organisations',
  'Admin.Environments' = 'Environments',
  'Admin.PendingApproval' = 'Pending Approval',
  'Admin.PendingApproval.Assessments' = 'Assessments',
  'Admin.PendingApproval.Feedback' = 'Feedback',
  'Admin.PendingApproval.Games' = 'Games',
  'Admin.PendingApproval.Zones' = 'Zones',
  'Admin.SupportTickets' = 'Support Tickets',
  'Admin.Languages' = 'Languages',
  'App' = 'Special Case Activities',
  'App.N4S' = 'Need 4 Speed',
  'App.DroneControl' = 'Drone Control',
  'Admin.Events' = 'Events',
  'Admin.ActiveEvents' = 'Active Events',
  'App.H4C' = 'Horses 4 Causes',
  'App.BTB' = 'Beat the Box',
  'App.QuickFire' = 'Quick Fire',
  'App.BP' = 'The Big Picture',
  'ImportGames' = 'Import Games',
  'ExportGames' = 'Export Games',
  'Admin.PendingApproval.WST' = "World's Strongest Team",
  'Facilitator' = 'Facilitator',
  'Facilitator.Portal' = 'Game Portal',
  'Facilitator.Spark' = 'Spark',
  'Facilitator.Assessment' = 'Assessment Portal',
}

export type PermissionType = keyof typeof Permission;
